import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=38aa5d73&scoped=true&"
import script from "./Validate.vue?vue&type=script&lang=js&"
export * from "./Validate.vue?vue&type=script&lang=js&"
import style0 from "./Validate.vue?vue&type=style&index=0&id=38aa5d73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa5d73",
  null
  
)

export default component.exports